// extracted by mini-css-extract-plugin
export default {"captchaWrapper":"dLNif","label":"JrhO7"};